var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import history from 'helpers/History';
import { loading } from 'elements/Loading';
import TableVoucher from '../../../components/TableVoucher';
var VoucherTable = /** @class */ (function (_super) {
    __extends(VoucherTable, _super);
    function VoucherTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSelectItem = function (value) {
            // history.push(`/voucher/${value.id}`)
            window.open(value.confirmation_url, '_blank');
        };
        return _this;
    }
    VoucherTable.prototype.componentDidMount = function () {
        var hasParent = (history.location.pathname.match(/\//g) || []).length >= 2;
        // this.props.store!.UI.changeHasParent(hasParent)
    };
    VoucherTable.prototype.render = function () {
        var voucherStore = this.props.store.voucherStore;
        var values = voucherStore.data.map(function (value) {
            var temp = __assign({}, value);
            temp.amount_paid = evalNumber(value.amount_paid);
            temp.receipt_total = evalNumber(value.receipt_total);
            return temp;
        });
        var headers = ['uuid', 'confirmation_url', 'status', 'receipt_total', 'amount_paid'];
        return (React.createElement(TableVoucher, { items: values, header: headers, onSelectItem: this.handleSelectItem, keyExtractor: function (item) { return String(item.id); }, loading: !voucherStore.loaded }));
    };
    VoucherTable = __decorate([
        inject('store'),
        loading(function (props) {
            return [
                props.store.voucherStore.read().then(function (vouchers) { return ({ vouchers: vouchers }); }),
            ];
        }),
        observer
    ], VoucherTable);
    return VoucherTable;
}(Component));
export default VoucherTable;
var evalNumber = function (numero) {
    var evalua = String(numero);
    var length = evalua.length;
    // console.log('length: ', length)
    if (length > 2) {
        var decimal = evalua.substring(length, length - 2);
        var entero = evalua.substring(length - 2, 0);
        // console.log('decimal: ', decimal)
        return "".concat(entero, ".").concat(decimal, "\u20AC");
    }
    else if (length === 2) {
        var decimal = evalua.substring(length, length - 2);
        return "0.".concat(decimal, "\u20AC");
    }
    else {
        return "0.0".concat(evalua, "\u20AC");
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/Vouchers/container/VoucherTable.tsx
// module id = 1538
// module chunks = 0